import useProjectResearchEntries from '../../hooks/portfolio/useProjectResearchEntries'
import countSubmissions from '../../helpers/dataHelpers/countSubmissions'
import latestActivity from '../../helpers/dataHelpers/latestActivity'

/**
 * Onderzoekskolom op het projectenoverzicht: hoe vaak is de vragenlijst van dit
 * project ingevuld, en wanneer kwam het laatste antwoord binnen.
 *
 * Geteld worden INVULLINGEN, niet documenten. Eén ingevulde vragenlijst schrijft
 * een document per vraag én per matrixrij, dus `responses.length` is een
 * veelvoud — op de productiegegevens mediaan 11x te hoog per organisatie.
 * AI-CONTEXT: See docs/pitfalls.md#database-totaldocs-overcounts-respondents
 *
 * 'Laatste' komt uit `latestActivity`, dat op de grootste tijdstempel kiest en
 * niet op een positie in de lijst — deze kolom pakte `responses.length - 1` uit
 * een AFLOPEND gesorteerde lijst en toonde daarmee het OUDSTE antwoord.
 *
 * De antwoorden komen via een Cloud Function: QuestionnairesResponses is
 * team-only, en wie dit overzicht bekijkt is lid van de koepel, niet van elk
 * project. De functie geeft alleen tijdstip en inzending-ID terug.
 * AI-CONTEXT: See docs/security-kaart-2026-10-22.md
 *
 * @param {object} props
 * @param {string} props.projectId - `CompagnyID` van het project waarvan de antwoorden geteld worden
 */
const ProjectResearchProgress = ({projectId}) => {
  const { docs: responses, error } = useProjectResearchEntries(projectId || '')

  // 'Nog niet geladen' is een eigen toestand: de leesengine geeft '' tot de
  // eerste snapshot binnen is, en 'nul invullingen' is dan een bewering aan de
  // lezer die niet waar hoeft te zijn.
  // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
  const loaded = Array.isArray(responses)
  const submissions = countSubmissions(responses)

  // Last result
  const last = latestActivity(responses)

if (error) {
  return (
    <div>
      <p className="project-progress project-progress--unknown" role="alert">Niet op te halen</p>
    </div>
  )
}

return (
  <div>
      <p className={`project-progress ${!loaded ? 'project-progress--unknown' : submissions === 0 ? 'project-progress--alert' : 'project-progress--ok'}`}>
        Invullingen: {loaded ? submissions : '–'}
      </p>
      {!loaded
        ? <p className="project-progress project-progress--unknown">Laatste: –</p>
        : last.atMs === null
          ? '-'
          : <p className={`project-progress ${last.daysAgo > 30 ? 'project-progress--alert' : 'project-progress--ok'}`}>Laatste: {last.label}</p>}
  </div>
)
}

export default ProjectResearchProgress
